import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { Pagination, Skeleton, Typography } from "@mui/material";
import RowContainer from "../../../common/RowContainer.js";
import ColumnContainer from "../../../common/ColumnContainer.js";
import { useGetTicketsByUserIdQuery } from "../../../../redux/features/tickets/ticketsApi.js";
import { TitleContainer, Wrapper } from "../../style.js";
import {
  changePageNumberTickets,
  getTicketsList,
} from "../../../../redux/features/tickets/ticketsSlice.js";
import TicketsList, { UserTicketsList } from "./UserTicketsList.js";
import { selectAuthData } from "../../../../redux/features/auth/authSlice.js";
import { FormattedMessage } from "react-intl";

export default function UserTicketsPage() {
  // INIT
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = useParams();

  // STATE
  const [filters, setFilters] = useState({
    ticket_status: null,
    category: null,
    company_name: null,
    updated_at: null,
    created_at: null,
  });
  const [currentPage, setCurrentPage] = useState(1);

  // FUNCTIONS

  const handleFilterStateChange = (value) => {
    setFilters(value);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    dispatch(changePageNumberTickets(value));
  };

  const handleCurrentPageChange = (value) => {
    setCurrentPage(value);
  };

  // REDUX
  const pageNumber = useSelector(
    (state) => state?.tickets?.ticketsList?.pagination?.pageNumber
  );
  const userData = useSelector(selectAuthData);
  const userId = userData?.userData?.id;

  const {
    data,
    isLoading,
    isError,
    refetch: refetchTickets,
  } = useGetTicketsByUserIdQuery(
    {
      userId: userId,
      page: currentPage,
      queryFilters: filters,
    },
    {
      skip: !userId,
    }
  );

  // EFFECTS
  useEffect(() => {
    if (data && !isLoading && !isError) {
      dispatch(getTicketsList(data));
    }
  }, [data, pageNumber, isLoading, isError, dispatch]);

  useEffect(() => {
    refetchTickets();
  }, [location.pathname, dispatch, refetchTickets]);

  return (
    <Wrapper>
      {isLoading ? (
        <RowContainer center>
          <Skeleton variant="rectangular" width={300} height={50} />
        </RowContainer>
      ) : isError ? (
        <RowContainer center>
          <Typography variant="h3" component="h3">
            <div>Error</div>
          </Typography>
        </RowContainer>
      ) : id ? (
        <Outlet />
      ) : (
        <ColumnContainer style={{ height: "100vh" }}>
          <ColumnContainer>
            <TitleContainer>
              <Typography variant="h3" component="h3">
                <FormattedMessage id="ticket.title.plural" />
              </Typography>
            </TitleContainer>
            <UserTicketsList
              tickets={data || []}
              paginationData={data?.pagination}
              notFilteredTickets={data?.not_filtered_tickets || []}
              onFilterStateChange={handleFilterStateChange}
              onTicketsPageChange={handleCurrentPageChange}
            />
          </ColumnContainer>
          <RowContainer center>
            {data?.pagination ? (
              <Pagination
                count={data?.pagination?.total_pages}
                page={data?.pagination?.active_page}
                onChange={handlePageChange}
              />
            ) : null}
          </RowContainer>
        </ColumnContainer>
      )}
    </Wrapper>
  );
}
